<template>
  <page-section
    :title="tableHeading ? tableHeading : $t('Integrations_Text_SyncHistory')"
  >
    <rest-list :payload="fetchEndpoint">
      <rest-list-column-date
        prop="create_time"
        :title="$t('TaskHistoryList_Field_CreateTime')"
        :width="200"
      />

      <rest-list-column-enum
        prop="identifier"
        :title="$t('TaskHistoryList_Field_Identifier')"
        :enum="filteredTaskIdentifiersLabels"
      />

      <rest-list-column prop="info" :title="$t('TaskHistoryList_Field_Info')" />

      <rest-list-column-enum
        prop="status"
        :title="$t('TaskHistoryList_Field_Status')"
        :enum="taskStatusLabel"
        :width="200"
      />

      <rest-list-column-actions>
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
          <rest-list-action-delete
            v-if="$isRole('admin')"
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="
              scope.row.identifier
                ? scope.row.identifier
                : $t('TaskHistoryList_Text_IdentifierNotAvailable')
            "
          />
        </template>
      </rest-list-column-actions>
    </rest-list>
  </page-section>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import {
  taskIdentifierLabel,
  taskStatusLabel
} from '@/modules/tasks/enum/TaskRecordEnums'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import PageSection from '@/common/components/page/PageSection'

export default {
  name: 'IntegrationTasksTable',

  components: {
    PageSection,
    RestList,
    RestListColumn,
    RestListColumnDate,
    RestListColumnEnum,
    RestListColumnActions,
    RestListActionView,
    RestListActionDelete
  },

  props: {
    integrationId: {
      type: Number,
      required: false
    },

    taskIdentifiers: {
      type: Array,
      required: true
    },

    tableHeading: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      taskStatusLabel
    }
  },

  computed: {
    filteredTaskIdentifiersLabels() {
      let labels = {}
      this.taskIdentifiers.forEach(identifier => {
        labels[identifier] = taskIdentifierLabel[identifier]
      })

      return labels
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `task-histories`,
        params: {
          sort: '-create_time',
          integration_id: this.integrationId
        }
      })
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `task-histories/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationTasksTable.vue